import {createUseStyles} from 'react-jss';
import loadArtemisFonts from '../../../v2/components/ui/loadArtemisFonts';
import MediaQueries from '../../../v2/style-helper/MediaQueries';

export default createUseStyles({
  headerContainer: {
    textAlign: 'center',
    marginBottom: props => ((props.isNewGuestUpdatedPage || props.shouldShowAppDownloadButtons) ? 18 : 42),
  },
  header: {
    fontFamily: props => props.theme.completePage.headerFontFamily,
    fontWeight: props => props.theme.completePage.headerFontWeight,
    fontSize: 42,
    lineHeight: '63px',
    color: '#212121',
    
    [MediaQueries.phone]: {
      lineHeight: props => props.isNewGuestUpdatedPage && 1.3,
      maxWidth: props => props.isNewGuestUpdatedPage && '90%',
      margin: props => props.isNewGuestUpdatedPage && 'auto',
    },
    
    extend: props => ({
      ...(props.isUsingArtemisStyles && props.theme.typography?.[props.theme.completePage.headerFont])
      && loadArtemisFonts(props.theme.typography[props.theme.completePage.headerFont], props.theme.completePage.isBoldHeader),
    }),
  },
  subHeader: {
    fontFamily: props => props.theme.completePage.subHeaderFontFamily,
    fontSize: props => props.theme.completePage.infoSubHeaderFontSize || 21,
    fontWeight: props => props.theme.completePage.subHeaderFontWeight,
    lineHeight: '21px',
    margin: 0,
    color: '#666',
    
    [MediaQueries.phone]: {
      display: props => props.isNewGuestUpdatedPage && 'none',
    },
  
    extend: props => ({
      ...(props.isUsingArtemisStyles && props.theme.typography?.[props.theme.completePage.subheaderFont])
      && loadArtemisFonts(props.theme.typography[props.theme.completePage.subheaderFont], props.theme.completePage.isBoldSubheader),
    }),
  },
});
